module.exports = __webpack_public_path__ + "img/support-bs-cta-mobile.36eb157.jpg";